import { TFunction } from 'react-i18next';

export function getLastEditedDate(
	t: TFunction<'myBosatlas'>,
	dateString?: string
): string {
	if (!dateString) return t('cards.notEdited');
	return t('cards.modifiedOnDate', { date: new Date(dateString) });
}
